@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Utah</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!-- Top Radio Group -->
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
                [hidden]="getRadioButtons(control)"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <h3 class="axis-h5">{{ textValues?.UM_Hading }}</h3>
      <!-- UM Radio Group level one -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
                [hidden]="getRadioButtons(control)"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- UM Radio Group level two -->
      @if (controls?.length >= 3) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[2].formControlName)?.touched &&
              reactiveForm.get(controls[2].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper
            class="_display-flex _align-items-center _justify-content-start"
            formControlName="{{ controls[2].formControlName }}"
          >
            @for (control of controls[2].option; track $index) {
              <axis-radio
                style="margin-right: 15px; margin-top: 0px"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
                [hidden]="getRadioButtons(control)"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[2].formControlName)?.touched) {
            @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      @if ((baseRules?.["UM_LiabilityLimit_DropDown"] || "").includes("readonly")) {
        <div class="axis-col-sm-6 axis-col-lg-6 axis-grid">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ controls[16].label }}</label>
            <div id="um_liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-utah">
              {{ controls[16].data[0].name }}
            </div>
          </div>
        </div>
      }

      <!-- UM Dropdowns -->
      @if (hasVisibleDropdowns("UM")) {
        <div class="axis-grid">
          @for (control of controls; track $index) {
            @if (
              baseRules[control.baseRuleKey]?.includes("show") &&
              (control.formControlName === "UMSplitLimits_DropDown" ||
                control.formControlName === "UMCombinedSingleLimit_DropDown" ||
                control.formControlName === "UMSplitMinLimits_DropDown" ||
                control.formControlName === "UMCombinedSingleMinLimit_DropDown")
            ) {
              <div class="axis-col-sm-6 axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(control.formControlName)?.value === null ||
                      reactiveForm.get(control.formControlName)?.value === '',
                    'has-axis-error':
                      reactiveForm.get(control.formControlName)?.touched &&
                      reactiveForm.get(control.formControlName)?.invalid,
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="{{ control.formControlName }}"
                  >
                    {{ control.label }}
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    >
                  </label>
                  <axis-dropdown
                    [dataProvider]="control.data"
                    id="{{ control.formControlName }}"
                    formControlName="{{ control.formControlName }}"
                    (onSelect)="handleDropdownSelection(control, $event)"
                  ></axis-dropdown>
                  @if (reactiveForm.get(control.formControlName)?.touched) {
                    @if (reactiveForm.get(control.formControlName)?.invalid) {
                      <span
                        class="axis-error-block"
                        role="alert"
                        >Please select the {{ control.label }}.</span
                      >
                    }
                  }
                </div>
              </div>
              @if (reactiveForm.get(control.formControlName)?.value?.info) {
                <div>{{ reactiveForm.get(control.formControlName)?.value?.info }}</div>
              }
            }
          }
        </div>
      }

      <!-- UIM Radio group level one -->
      <h3 class="axis-h5">{{ textValues?.UIM_Hading }}</h3>
      @if (controls?.length >= 4) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[3].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[3].formControlName)?.touched &&
              reactiveForm.get(controls[3].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[3].formControlName }}">
            @for (control of controls[3].option; track $index) {
              <axis-radio
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[3].formControlName }}"
                [hidden]="getRadioButtons(control)"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[3].formControlName)?.touched) {
            @if (reactiveForm.get(controls[3].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <!-- UIM Radio group level two -->
      @if (controls?.length >= 5) {
        @if (
          (baseRules?.["UIMSplitLimits_LevelTwoUIM_Radio"] || "UIMCombinedSingleLimit_LevelTwoUIM_Radio").includes(
            "show"
          )
        ) {
          <div
            class="axis-form-group _mt-medium"
            [ngClass]="{
              'has-axis-required': reactiveForm.get(controls[4].formControlName)?.value === null,
              'has-axis-error':
                reactiveForm.get(controls[4].formControlName)?.touched &&
                reactiveForm.get(controls[4].formControlName)?.invalid,
            }"
          >
            <axis-radio-button-wrapper
              class="_display-flex _align-items-center _justify-content-start"
              formControlName="{{ controls[4].formControlName }}"
            >
              @for (control of controls[4].option; track $index) {
                <axis-radio
                  style="margin-right: 15px; margin-top: 0px"
                  heading="{{ control.label }}"
                  value="{{ control.select }}"
                  name="{{ controls[4].formControlName }}"
                  [hidden]="getRadioButtons(control)"
                ></axis-radio>
              }
            </axis-radio-button-wrapper>
            @if (reactiveForm.get(controls[4].formControlName)?.touched) {
              @if (reactiveForm.get(controls[4].formControlName)?.invalid) {
                <span
                  class="axis-error-block"
                  role="alert"
                  >Please select an option.</span
                >
              }
            }
          </div>
        }
      }

      @if ((baseRules?.["UIM_LiabilityLimit_DropDown"] || "").includes("readonly")) {
        <div class="axis-col-sm-6 axis-col-lg-6 axis-grid">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ controls[17].label }}</label>
            <div id="uim_liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-utah">
              {{ controls[17].data[0].name }}
            </div>
          </div>
        </div>
      }

      <!-- UIM Dropdowns -->
      @if (hasVisibleDropdowns("UIM")) {
        <div class="axis-grid">
          @for (control of controls; track $index) {
            @if (
              baseRules[control.baseRuleKey]?.includes("show") &&
              (control.formControlName === "UIMSplitLimits_DropDown" ||
                control.formControlName === "UIMCombinedSingleLimit_DropDown" ||
                control.formControlName === "UIMSplitMinLimits_DropDown" ||
                control.formControlName === "UIMCombinedSingleMinLimit_DropDown")
            ) {
              <div class="axis-col-sm-6 axis-col-md-6">
                <div
                  class="axis-form-group"
                  [ngClass]="{
                    'has-axis-required':
                      reactiveForm.get(control.formControlName)?.value === null ||
                      reactiveForm.get(control.formControlName)?.value === '',
                    'has-axis-error':
                      reactiveForm.get(control.formControlName)?.touched &&
                      reactiveForm.get(control.formControlName)?.invalid,
                  }"
                >
                  <label
                    class="axis-control-label"
                    for="{{ control.formControlName }}"
                  >
                    {{ control.label }}
                    <span
                      aria-hidden="true"
                      class="axis-required-indicator"
                      >*</span
                    >
                  </label>
                  <axis-dropdown
                    [dataProvider]="control.data"
                    id="{{ control.formControlName }}"
                    formControlName="{{ control.formControlName }}"
                    (onSelect)="handleDropdownSelection(control, $event)"
                  ></axis-dropdown>
                  @if (reactiveForm.get(control.formControlName)?.touched) {
                    @if (reactiveForm.get(control.formControlName)?.invalid) {
                      <span
                        class="axis-error-block"
                        role="alert"
                        >Please select the {{ control.label }}.</span
                      >
                    }
                  }
                </div>
              </div>
            }
          }
        </div>
      }
      <!-- UIM Min Dropdown -->
      <div class="axis-grid">
        @if ((baseRules?.["UIMSplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label"> {{ controls[12].label }} </label>
              <div id="uimsplitminlimits_10k_20k-pdffield-utah">{{ controls[12].data[0].name }}</div>
            </div>
          </div>
        }
        @if ((baseRules?.["UIMCombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label"> {{ controls[13].label }} </label>
              <div id="uimcombinedsingleminlimit_20k-pdffield-utah">{{ controls[13].data[0].name }}</div>
            </div>
          </div>
        }
      </div>
      @if (baseRules?.["UIMReject_LevelOneUIM_Radio"] === "Yes") {
        <div class="axis-form-group">
          <label
            id="uimreject_leveloneuim_radio-pdffield-utah"
            class="axis-control-label"
          >
            {{ textValues?.Rejects_UIM }}
          </label>
        </div>
      }

      <!-- UMPD Radio group level one -->
      <h3 class="axis-h5">{{ textValues?.UMPD_Hading }}</h3>
      <p>{{ textValues?.UMPD_Subheading }}</p>
      @if (controls?.length >= 6) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[5].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[5].formControlName)?.touched &&
              reactiveForm.get(controls[5].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[5].formControlName }}">
            @for (control of controls[5].option; track $index) {
              <axis-radio
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[5].formControlName }}"
                [hidden]="getRadioButtons(control)"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[5].formControlName)?.touched) {
            @if (reactiveForm.get(controls[5].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }
      <!-- UMPD Dropdown -->
      <div class="axis-grid">
        @for (control of controls; track $index) {
          @if (baseRules[control.baseRuleKey]?.includes("show") && control.formControlName === "UMPDLimits_DropDown") {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>

      <!-- UMPD Min Dropdown values readonly display -->
      <div class="axis-grid">
        @if ((baseRules?.["UMPDMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label"> {{ controls[15].label }} </label>
              <div id="umpdminlimits_the_lesser_of_the_vehicles_actual_cash_value_or_3500-pdffield-utah">
                {{ controls[15].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>

      <!-- UMPD Min Dropdown -->
      <div class="axis-grid">
        @for (control of controls; track $index) {
          @if (
            baseRules[control.baseRuleKey]?.includes("show") && control.formControlName === "UMPDMinLimits_DropDown"
          ) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>
    </form>
    @if (baseRules?.UMPDReject_LevelOneUMPD_Radio === "Yes") {
      <div class="axis-form-group">
        <label
          id="umpdreject_leveloneumpd_radio-pdffield-utah"
          class="axis-control-label"
        >
          {{ textValues?.Rejects_UMPD }}
        </label>
      </div>
    }
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Utah</h2>

  <!-- Reject texts -->
  @if (baseRules?.UMReject_LevelOneUM_Radio) {
    <div class="axis-form-group">
      <label
        id="umreject_leveloneum_radio-pdffield-utah"
        class="axis-control-label"
      >
        {{ textValues?.Rejects_UM }}
      </label>
    </div>
  }
  @if (
    baseRules?.UMPDReject_LevelOneUMPD_Radio &&
    baseRules?.["selectionId"] !== "PolicyLiabilityLimits_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage"
  ) {
    <div class="axis-form-group">
      <label
        id="umpdreject_leveloneumpd_radio-pdffield-utah"
        class="axis-control-label"
      >
        {{ textValues?.Rejects_UMPD }}
      </label>
    </div>
  }
  @if (baseRules?.UIMReject_LevelOneUIM_Radio) {
    <div class="axis-form-group">
      <label
        id="uimreject_leveloneuim_radio-pdffield-utah"
        class="axis-control-label"
      >
        {{ textValues?.Rejects_UIM }}
      </label>
    </div>
  }

  <!-- DROPDOWN VALUES -->
  @if (
    baseRules?.["selectionId"] !== "PolicyLiabilityLimits_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage"
  ) {
    <div class="axis-grid">
      @for (control of controls | slice: 5; track $index) {
        @if (baseRules[control.baseRuleKey]) {
          <div class="axis-col-sm-6 axis-col-lg-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ control.label }}</label>
              <div>{{ control.data[0].name }}</div>
            </div>
          </div>
        }
      }
    </div>
  } @else {
    <h3 class="axis-h5">{{ textValues?.UM_Hading }}</h3>

    @if (baseRules[controls[16].baseRuleKey]) {
      <div class="axis-form-group">
        <label class="axis-control-label">{{ controls[16].label }}</label>
        <div>{{ controls[16].data[0].name }}</div>
      </div>
    }
    <h3 class="axis-h5">{{ textValues?.UIM_Hading }}</h3>
    @if (baseRules[controls[17].baseRuleKey]) {
      <div class="axis-form-group">
        <label class="axis-control-label">{{ controls[17].label }}</label>
        <div>{{ controls[17].data[0].name }}</div>
      </div>
    }
    <h3 class="axis-h5">{{ textValues?.UMPD_Hading }}</h3>
    <p>{{ textValues?.UMPD_Subheading }}</p>
    @if (
      baseRules?.UMPDReject_LevelOneUMPD_Radio &&
      baseRules?.["selectionId"] === "PolicyLiabilityLimits_CombinedSingleLimit_BodilyInjuryWithMandatoryPropertyDamage"
    ) {
      <div class="axis-form-group">
        <label
          id="umpdreject_leveloneumpd_radio-pdffield-utah"
          class="axis-control-label"
        >
          {{ textValues?.Rejects_UMPD }}
        </label>
      </div>
    }
  }
}
